import { useEffect, useState } from "react";
import { getCssVariable, highlightUnderscoreText } from "src/utils/utils";
import { Typography } from "src/components/shared";
import Layout from "../Layout/Layout";
import { client } from "src/utils/api";
import { useLocation, useNavigate } from "react-router-dom";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types";

const RichTextRenderer = ({ richTextJson }) => {

  if (!richTextJson || typeof richTextJson === 'string' || !richTextJson.nodeType) {
    // Return empty or fallback content if not a valid rich text document
    return <div>{typeof richTextJson === 'string' ? richTextJson : null}</div>;
  }

  const options = {
    renderMark: {
      [MARKS.BOLD]: (text) => <strong className="bold">{text}</strong>,
      [MARKS.ITALIC]: (text) => <em>{text}</em>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        if (
          node.content.length === 1 &&
          node.content[0].nodeType === 'text' &&
          node.content[0].value === ''
        ) {
          return <br />;
        }

        return <p>{children}</p>;
      },
      [INLINES.HYPERLINK]: (node, children) => {
        return (
          <a
            href={node.data.uri}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: "16px", lineHeight: 0 }}
          >
            {children}
          </a>
        );
      },
    },
  };

  return <div>{documentToReactComponents(richTextJson, options)}</div>;
};

const AdobeSummit = () => {
  const gqlClient = client;
  const primaryColor = getCssVariable("--primary-color");
  const navigate = useNavigate();
  const location = useLocation();
  const pathParts = location.pathname.toLowerCase().split("/").filter(Boolean);
  const isBaseRoute = pathParts.length === 1 && pathParts[0] === "hiddenheroes";
  const slug = isBaseRoute ? "hiddenheroes" : pathParts[1];
  const [summitData, setSummitData] = useState<any[]>([]);

  useEffect(() => {
    const featchSummitPage = async () => {
      try {
        const productResponse = await gqlClient.GetPageSummitBySlug({
          slug: slug,
        });

        const summitId =
          productResponse?.pageGenericCollection?.items[0]?.sys.id;

        if (!summitId) {
          navigate("/not-found", { replace: true });
          return;
        }
        const [responseOne] = await Promise.all([
          gqlClient.GetAdobePage({ id: summitId }),
        ]);

        const componentsOne =
          responseOne?.pageGeneric?.componentsCollection?.items || [];

        const cleanedData = [...componentsOne].filter(
          (item) => item && item.sys?.id && Object.keys(item).length > 2
        );

        setSummitData(cleanedData);
      } catch (error) { }
    };

    featchSummitPage();
  }, [slug]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      if ((window as any).hbspt) {
        (window as any).hbspt.forms.create({
          portalId: "45649448",
          formId: "c1414505-f881-4b8e-9a43-6c4db2e34704",
          target: "#hubspotForm",
        });
      }
    });
  }, []);

  const mainData = summitData[0];
  const cardCollection = mainData?.cardCollection?.items;
  const descriptionText =
    mainData?.banner?.heroFieldDescriptionJson?.json?.content?.[0]?.content?.[0]?.value ?? "";
  const titleRTF =
    mainData?.banner?.titleRtf ?? "";

 
  

  return (
    <Layout
      style={{
        color: "#fff",
      }}
      hamburgerStyle={{
        backgroundColor: primaryColor,
      }}
      saleClassName={"btn-gradient-bdr"}
      headerStyle={{ position: "relative" }}
      seoData={mainData?.seoFields}
    >
      <section style={{ paddingBottom: "200px" }}>
        <div className="summit-banner">
          <div
            style={{
              width: "100%",
              display: "flex",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className="container-fluid custom-spacer-col summit-banner-type"
              style={{
                backgroundImage: `url(${mainData?.banner?.backgroundImage?.url})`,
              }}
            >
              <div className="banner-content mt-4">
                <Typography tag="h2">{mainData?.banner?.backgroundImage?.title}</Typography>
                <Typography tag="h4" className="light mt-2">
                  {descriptionText}
                </Typography>

                <span
                  dangerouslySetInnerHTML={{
                    __html: highlightUnderscoreText(
                      titleRTF ?? ""),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="summit-event-component">
          <div className="container-fluid custom-spacer-col pt-60">
            {/* Left Column  */}
            <div className="summit-event-top-container">
              <div className="d-flex flex-column align-items-start pe-m-0 max-w-450 summit-event-top-container-left">
                <div style={{ fontWeight: 400, fontSize: "52px", lineHeight: "120%", letterSpacing: "-0.03em" }}
                  dangerouslySetInnerHTML={{
                    __html: highlightUnderscoreText(
                      mainData?.title ?? ""),
                  }}
                ></div>
                <div className="grey-medium-dark mx-w-450 mb-20">
                  {/* FIXED: Pass the entire description.json object instead of just the value */}
                  {mainData?.description?.json && (
                    <RichTextRenderer
                      richTextJson={mainData?.description?.json}
                    />
                  )}
                </div>
              </div>
              <div className="col-md-6 form-container" id="form-container">
                <h2 className="header-4 black fw-bold mb-20">
                  Sign up to connect
                </h2>
                <div>
                  <div id="hubspotForm"></div>
                </div>
              </div>
            </div>
            <div className="summit-event-info">
              {cardCollection &&
                cardCollection.map((card: any, index: number) => (
                  <div className="summit-event-info-item" key={card.sys.id}>
                    <div
                      className={`summit-image-container`}
                      style={{
                        position: "relative",
                        minWidth: "100px",
                        minHeight: "400px",
                        borderRadius: "6px",
                        backgroundImage: card.cardImage?.url
                          ? `url(${card.cardImage.url})`
                          : "none",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    ></div>
                    <div className="grey-medium-dark mx-w-450">
                      {card.cardDescription?.json && (
                        <RichTextRenderer
                          richTextJson={card.cardDescription.json}
                        />
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AdobeSummit;